import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FileUploadAPI, PostAPI, PutAPI } from '../ultilies/API';
import '../css/commonForm.css';
import { ApiUrls } from '../ultilies/Variables';
import { FormAPI } from '../ultilies/FormAPI';

function CategoryForm() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const isEdit = !!state;

    const [formData, setFormData] = useState({
        name: state?.name || '',
        shortTitle: state?.shortTitle || '',
        categoryIcon: state?.gameCategoryIconPath || null,
        categoryBanner: state?.gameCategoryBannerPath || null,
        type: 'game_category',
        id : state?._id || null
    });
    console.log("CategoryForm_formData", formData);
    
    const [iconFile, setIconFile] = useState(null)
    const [bannerFile, setBannerFile] = useState(null)

    const [previews, setPreviews] = useState({
        icon: ApiUrls.imediaroot+state?.gameCategoryIconPath || null,
        banner:  ApiUrls.imediaroot+state?.gameCategoryBannerPath || null
    });

    const handleUpload = (e, field) => {
        const file = e.target.files[0];
        if (file) {
            setPreviews({ ...previews, [field]: URL.createObjectURL(file) });
            if (field === 'icon') {                
                setIconFile(file);
            } else if (field === 'banner') {
                setBannerFile(file);
            }
        }
    };

    const handleSave = () => {
        const url = isEdit ? `/edit` : `/create`;
        const recordId = isEdit ? formData.id : null;

        const payload = isEdit ? { ...formData, id: recordId } : formData;

        PostAPI(url, payload, (res) => {
            if (res?.success) {
                const targetId = recordId || res?.data?.id || res?.data?._id;
                if (targetId && (iconFile || bannerFile)) {
                    const uploadData = new FormData();

                    if (iconFile) uploadData.append('icon', iconFile);
                    if (bannerFile) uploadData.append('banner', bannerFile);

                    uploadData.append('id', targetId);
                    uploadData.append('type', formData.type);

                    FileUploadAPI(uploadData, (uploadRes) => {
                        console.log("Upload Success:", uploadRes);
                        alert(isEdit ? "Updated successfully with files!" : "Created successfully with files!");
                        navigate('/gamecategories');
                    });
                } else {
                    alert(isEdit ? "Updated successfully!" : "Created successfully!");
                    navigate('/gamecategories');
                }
            } else {
                alert("Operation failed: " + (res?.message || "Unknown error"));
            }
        });
    };

    const newHandleSubmit = () => {
        const apiUrl = ApiUrls.StaticPlayableApiUrl;
        let input_map = {}
        input_map.url = apiUrl
        input_map.body = formData
        FormAPI.Post_fetch(input_map)
    }

    return (
        <div className="cat-form-container">
            {/* <div className="preview-side">
                <div className="cat-card-preview">
                    <div className="cat-banner-box">
                        {previews.banner && <img src={previews.banner} alt="Banner" />}
                    </div>
                    <div className="cat-icon-box">
                        {previews.icon && <img src={previews.icon} alt="Icon" />}
                    </div>
                    <h4>{formData.name || "Category Name"}</h4>
                    <p>{formData.shortTitle || "Description summary..."}</p>
                </div>
            </div> */}

            <div className="fields-side">
                <h2>{isEdit ? 'Edit Category' : 'Create Category'}</h2>

                <label htmlFor='category-name'>Category Name</label>
                <input type="text" id='category-name' value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} placeholder="e.g. Custom Games" />

                <label htmlFor='short-title'>Short Title (Description)</label>
                <textarea id='short-title' value={formData.shortTitle} onChange={e => setFormData({ ...formData, shortTitle: e.target.value })} placeholder="Describe this category..." />

                <div className="file-upload-row">
                    {/* ICON UPLOAD */}
                    <div style={{ flex: 1 }}>
                        <label>Category Icon (.webp)</label>
                        <div className="upload-box" onClick={() => document.getElementById('category-icon').click()}>
                            {iconFile || (isEdit && previews.icon) ? (  
                                <div className="file-attached">
                                    <span>{iconFile ? iconFile.name : state?.gameCategoryIconFileName}</span>
                                    {/* <button type="button" onClick={(e) => removeFile(e, 'icon')}>Remove</button> */}
                                </div>
                            ) : (
                                <>
                                    <p>Click to upload icon</p>
                                    <small>Webp form preferred</small>
                                </>
                            )}
                            <input
                                type="file"
                                id="category-icon"
                                hidden
                                accept=".webp,image/*"
                                onChange={e => handleUpload(e, 'icon')}
                            />
                        </div>
                    </div>

                    {/* BANNER UPLOAD */}
                    <div style={{ flex: 1 }}>
                        <label>Category Banner (.webp)</label>
                        <div className="upload-box" onClick={() => document.getElementById('category-banner').click()}>
                            {bannerFile || (isEdit && previews.banner) ? (
                                <div className="file-attached">
                                    <span>{bannerFile ? bannerFile.name : state?.gameCategoryBannerFileName}</span>
                                    {/* <button type="button" onClick={(e) => removeFile(e, 'banner')}>Remove</button> */}
                                </div>
                            ) : (
                                <>
                                    <p>Click to upload banner</p>
                                    <small>WebP format preferred</small>
                                </>
                            )}
                            <input
                                type="file"
                                id='category-banner'
                                hidden
                                accept=".webp,image/*"
                                onChange={e => handleUpload(e, 'banner')}
                            />
                        </div>
                    </div>

                </div>
                <div style={{marginTop:"40px"}}>
                    <button className="cancel-btn" onClick={() => navigate('/gamecategories')}>Cancel</button>
                    <button className="save-btn" onClick={handleSave}>Save Category</button>
                </div>
            </div>
        </div>
    );
}

export default CategoryForm;